"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
exports.defaultState = {
    sidebarlist: []
};
exports.EditContext = react_1.createContext(undefined);
exports.useSidebar = function () {
    var _a = react_1.useState(exports.defaultState), state = _a[0], setState = _a[1];
    var ctx = __assign(__assign(__assign({}, state), {
        pushSidebarItem: function (item, exclusive) {
            if (exclusive === void 0) { exclusive = true; }
            var sl = exclusive ? [] : state.sidebarlist.splice(0);
            sl.push(item);
            setState({ sidebarlist: sl });
        },
        popSidebarItem: function () {
            var sl = state.sidebarlist.splice(0);
            sl.pop();
            setState({ sidebarlist: sl });
        },
        clearSidebarList: function () {
            setState({ sidebarlist: [] });
        }
    }), { apply: function (block) { } });
    return ctx;
};
